import React from 'react';
import { useNavigate } from 'react-router-dom';
import main from '../../main';
import { Goods } from '../../types';
interface Props {
  list: Goods[];
}
export default function PopularityItem({ list }: Props) {
  const navigate = useNavigate();
  let uc = main.uc;
  return (
    <div
      className="popularity-block popularity-bg mt-0 ml-8"
      style={{
        background: 'url("/pic/img_popularity_bg.png")',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="pl-8 pr-8 pt-20">
        <img className="popularity-tag" src="/pic/img_popularity_tag.png" alt="" />
        <div className="mt-0 d-flex-r">
          {list.map((item, idx) => (
            <div
              className="popularity-item d-flex-c mr-12 border-radius-12 overflow-hidden"
              key={idx}
              onClick={() => navigate('/product?code=' + item.goodsCode + `${uc ? '&uc=' + uc : ''}`)}
            >
              <div className="pos-r">
                <img className="item-headimg" src={item.goodsHeadImg} alt="" />
                <img className="pos-a r-0 t-0 w-50" src="/pic/img_hot.png" alt="" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
